import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { mathJsExpressionSchema } from '@zaoblako/shared/modules/serde/schemas/math-js-expression.schema';

import * as yup from 'yup';

/** Balance report format COMPUTED row create or update request body */
export interface BalanceReportComputedRowFormInterface {
  /** Row display name */
  name: string;
  /** Row formula */
  formula: string;
  /** Row measure to display */
  measure?: string;
  /** Row custom color */
  color?: string;
}

export const BalanceReportComputedRowFormDto = SerdeDtoClass.create<BalanceReportComputedRowFormInterface>(
  FinanceDtoKeysEnum.BALANCE_REPORT_COMPUTED_ROW_FORM_DTO,
  {
    name: {
      label: 'Название',
      hint: 'Название этой строки в ОПиУ',
      serializer: yup
        .string()
        .min(1, DtoMessageEnum.EMPTY_STRING),
    },
    formula: {
      label: 'Формула',
      hint: 'Математическая формула, по которой вычисляются значения этой строки в ОПиУ',
      serializer: mathJsExpressionSchema,
    },
    measure: {
      label: 'Единица измерения',
      hint: 'Суффикс, отображающий единицу измерения (например, "%"). Будет показан после вычисленного значения.',
      optional: true,
      serializer: yup.string(),
    },
    color: {
      label: 'Цвет строки',
      hint: 'Специальный цвет, которым нужно подсветить эту строку',
      optional: true,
      serializer: hexColorSchema,
    },
  },
);
